import React from 'react'

// icons
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// routes
import { withRouter } from 'react-router-dom'
import useDeleteDepartment from './hooks/useDeleteDepartment'

const ItemDepartamento = ({ departamento, history, setIsLoad }) => {
    const { deleteDepartamento } = useDeleteDepartment(setIsLoad)
    return (
        <tr key={parseInt(departamento.id)}>
            <th scope="row">{departamento.codigo}</th>
            <td>{departamento.nombre}</td>
            <td>{departamento.tasaIva} %</td>
            <td>
                <button
                    className="btn text-danger"
                    onClick={() => {
                        history.push(`/edit-departamento/${departamento.id}`, {
                            departamento: departamento,
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                    className="btn text-primary"
                    onClick={() => {
                        deleteDepartamento(departamento)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemDepartamento)
